import { http } from '@/http'
import { dataShared } from '../store'

const C_PREFIX = 'client/'

class AssessmentService {
    static getOverview(trainingId) {
        const cId = dataShared.getters.getDataByUserLogged

        console.log(cId)

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }

        return http.get(`${C_PREFIX}trainings/${trainingId}/assessment`, headers)
    }

    static startAttempt(trainingId) {
        const cId = dataShared.getters.getDataByUserLogged

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }

        return http.post(`${C_PREFIX}trainings/${trainingId}/assessment/attempts`, {}, headers)
    }

    static submitAnswers(attemptId, answersArray) {
        // answersArray: [{ question_id, option_id }, ...]
        const cId = dataShared.getters.getDataByUserLogged

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }
        
        return http.post(`${C_PREFIX}assessment-attempts/${attemptId}/answers`, { answers: answersArray }, headers)
    }

    static finalizeAttempt(attemptId, data) {
        const cId = dataShared.getters.getDataByUserLogged

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }
        
        return http.post(`${C_PREFIX}assessment-attempts/${attemptId}/finalize`, data, headers)
    }

    static heartbeat(attemptId, payload = {}) {
        const cId = dataShared.getters.getDataByUserLogged

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }
        
        return http.post(`${C_PREFIX}assessment-attempts/${attemptId}/heartbeat`, payload, headers)
    }

    static getAttemptReview(attemptId) {
        const cId = dataShared.getters.getDataByUserLogged

        const headers = {
            headers: {
                customerId: cId?.id
            }
        }

        return http.get(`${C_PREFIX}assessment-attempts/${attemptId}/review`, headers)
    }


}

export default AssessmentService